import { IState } from '../../store';
import { abUseExperimentsSelector, isAbUseExperimentsActive } from '../abUseExperiments';

export const NEWBUILDING_OFFER_REDESIGN_EXPERIMENT = 'newbuilding_offer_card_redesign_v3';

export const selectIsOfferRedesignExperimentActive = (state: IState) => {
  const experiments = abUseExperimentsSelector(state);

  return isAbUseExperimentsActive(experiments, NEWBUILDING_OFFER_REDESIGN_EXPERIMENT, 'enabled');
};
